<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-6">
        <SessionStatistics
          class="h-full"
          :sessions="reports.sessions"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-6">
        <MessagesStatistics
          class="h-full"
          :messages="reports.messages"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-6">
        <ExitReasonStatistics
          class="h-full"
          :exit_reasons="reports.sessions.exit_reasons"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-6">
        <PopularityStatistics
          class="h-full"
          :scenario="reports.scenario"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-6">
        <ClickStatistics
          class="h-full"
          :clicks="reports.clicks"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-6">
        <ViewsStatistics
          class="h-full"
          :visits="reports.visits"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MessagesStatistics from './MessagesStatistics'
import ExitReasonStatistics from './ExitReasonStatistics'
import ClickStatistics from './ClickStatistics'
import PopularityStatistics from './PopularityStatistics'
import SessionStatistics from './SessionStatistics'
import ViewsStatistics from './ViewsStatistics'

export default {
  props: {
    reports: {
      required: true,
      type: Object
    }
  },

  components: {
    MessagesStatistics,
    ExitReasonStatistics,
    ClickStatistics,
    PopularityStatistics,
    SessionStatistics,
    ViewsStatistics
  }
}
</script>
